// extracted by mini-css-extract-plugin
export var active = "_8o-a";
export var activeIndicator = "_8o-9";
export var disabled = "_8o-b";
export var fullWidth = "_8o-2";
export var lg = "_8o-7";
export var md = "_8o-6";
export var redoButtonTabGroup = "_8o-0";
export var sm = "_8o-5";
export var tabButton = "_8o-4";
export var tabButtonsContainer = "_8o-1";
export var themeDestructive = "_8o-d";
export var themeNormal = "_8o-c";
export var themeSuccess = "_8o-e";
export var xl = "_8o-8";
export var xs = "_8o-3";